import { render, staticRenderFns } from "./MoreFilter.vue?vue&type=template&id=1b1311c2&scoped=true"
import script from "./MoreFilter.vue?vue&type=script&lang=ts"
export * from "./MoreFilter.vue?vue&type=script&lang=ts"
import style0 from "./MoreFilter.vue?vue&type=style&index=0&id=1b1311c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1311c2",
  null
  
)

export default component.exports